<div
  class="app"
  *ngIf="showLayout$ | async; else noLayout"
  [class.no-sidebar]="(showSidebar$ | async) === false"
>
  <app-sidebar *ngIf="showSidebar$ | async"></app-sidebar>
  <main class="main">
    <app-topbar></app-topbar>
    <app-terms-prompt></app-terms-prompt>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<ng-template #noLayout>
  <router-outlet></router-outlet>
</ng-template>
